import React, { useRef } from "react";
import { motion } from "framer-motion";

/**
 * MagneticButton wraps its child with a subtle mouse-following transform.
 * Use sparingly on hero CTAs.
 */
export default function MagneticButton({ children, strength = 0.25, className = "", ...rest }) {
    const ref = useRef(null);

    const handleMove = (e) => {
        const el = ref.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        const x = (e.clientX - (r.left + r.width / 2)) * strength;
        const y = (e.clientY - (r.top + r.height / 2)) * strength;
        el.style.transform = `translate(${x}px, ${y}px)`;
    };

    const reset = () => {
        const el = ref.current;
        if (el) el.style.transform = "translate(0, 0)";
    };

    return (
        <motion.div
            ref={ref}
            onMouseMove={handleMove}
            onMouseLeave={reset}
            className={`inline-block will-change-transform transition-transform duration-300 ease-out ${className}`}
            {...rest}
        >
            {children}
        </motion.div>
    );
}
